import axios from 'axios';
import useConfiguration from '@/composables/useConfiguration';

const client = axios.create({
    baseURL: import.meta.env.VITE_API_HOST + import.meta.env.VITE_API_BASEPATH,
});

export default function useSpeech() {
    const { assistent } = useConfiguration();

    async function createSpeech(textInput: string): Promise<any> {
        if (assistent.value === undefined) {
            return null;
        }

        const response = await client.post(`/ai/assistent/assistents/${assistent.value.id.value}/create_speech`, {
            message: textInput,
        }, {
            responseType: 'arraybuffer',
        });

        const audioBlob = new Blob([response.data], { type: 'audio/mp3' });
        const audioURL = URL.createObjectURL(audioBlob);

        return new Audio(audioURL);
    }

    return {
        createSpeech,
    };
}
